<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/D2cW2v/tc-custom/9781504087506.jpg?1740715141516" alt="This image is the cover for the book Agreement"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Agreement
      </h1>
      <p class="bookDescription body article font2">
        <b>A twisting new thriller from the author of <i>The Replacement</i>: Is the man she married in trouble—or is <i>he</i> just trouble?</b><br/><br/> Kate and Jake agreed when they got married that they would always give each other space. But lately, Jake seems to want a lot more space than Kate’s comfortable with. He’s growing more distant with every day. In an angry attempt to figure out why, she doesn’t take the turn for their road on the way home from work. She keeps on driving and takes a room at a local hotel to conduct a bit of spying—and discovers some worrisome information.<br/><br/> But when she returns home to confront him, Jake isn’t just emotionally distant—he’s gone, along with all his things. All that remains is a lone laptop with a map of everywhere she has been over the past days and a timer that is ticking down . . .<br/><br/> Kate turns to the police, who just think she’s been dumped. Then comes an anonymous threat and a demand for money. Nothing seems to make sense. Will she ever get her husband back? And does she really want to?<br/><br/><b>Praise for Jacqueline Ward’s novels</b><br/><br/> “Wildly entertaining and compelling.” —<i>Daily Mail</i><br/><br/> “Tense and gripping.” —Sanjida Kay, author of <i>My Mother’s Secret</i><br/><br/> “Hugely engrossing.” —Catherine Ryan Howard, Edgar Award finalist
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jacqueline Ward
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?58dfdb5e